<template lang="pug">
v-dialog(v-model="show", persistent, max-width="50%")
    v-card(v-if="fatura")
        v-card-title
            v-flex.md8
                .title Taxa de Serviço
                a(href="https://sites.bigou.com.br/saiba-mais-sobre-a-taxa-de-serviço-do-bigou-delivery", target="_blank").accent--text O que é Taxa de Serviço?
            v-flex.md4.text-xs-right
              v-btn(flat, @click="close()", density="comfortable", icon="", variant="plain")
                v-icon close
        v-card-text
            template
                h4.pt-3(style="font-size: 18px; color:#1113128A; font-weight:500") Cálculo do total de taxas de serviço
                div(style="background-color:#FAFAFA; border-radius:8px").pa-3.mt-4.mb-4
                    v-layout(row, wrap).pb-4
                        v-flex.md8.xs12(style="font-size:18px; color:#111312CC")
                            label <strong>  {{(fatura.indicadores ? fatura.indicadores.quantidadeTaxaServicoPgtOnline : 0)}} vendas </strong> confirmadas com pagamento online
                        v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#111312CC")
                            strong -{{ (fatura.indicadores ? fatura.indicadores.totalTaxaServicoPgtOnline : 0) | currency }}
                    v-layout(row, wrap).pb-4
                        v-flex.md8.xs12(style="font-size:18px; color:#111312CC")
                            label <strong>  {{(fatura.indicadores ? fatura.indicadores.quantidadeTaxaServicoDinheiro : 0)}} vendas </strong> confirmadas em dinheiro
                        v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#111312CC")
                            strong -{{ (fatura.indicadores ? fatura.indicadores.totalTaxaServicoDinheiro : 0) | currency }}
                    v-layout(row, wrap)
                        v-flex.md8.xs12(style="font-size:18px; color:#111312CC;")
                            label <strong>  {{(fatura.indicadores ? fatura.indicadores.quantidadeTaxaServicoMaquininha : 0)}} vendas </strong> confirmadas com maquininha de cartão
                        v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#111312CC")
                            strong -{{ (fatura.indicadores ? fatura.indicadores.totalTaxaServicoMaquininha : 0) | currency }}
                div(style="border:1px solid; border-radius:8px; color:#0000000A").pa-3.mt-4.mb-4
                    v-layout(row, wrap)
                        v-flex.md8.xs12(style="font-size:18px; color:#111312")
                            strong Total das taxas de {{(fatura.indicadores ? fatura.indicadores.quantidadeTaxaServico : 0)}} vendas confirmadas
                        v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#111312CC")
                            strong -{{ (fatura.indicadores ? fatura.indicadores.totalTaxaServico : 0) | currency }}
                div(style="border:1px solid; border-radius:8px; color:#0000000A", v-if="fatura.venda && fatura.venda.taxa_servico_maquininha && fatura.indicadores.quantidadeTaxaServicoMaquininha").pa-3.mt-4.mb-4
                    v-layout(row, wrap)
                        v-flex.md8.xs12(style="font-size:18px; color:#111312")
                            strong Valor da taxa de maquininha de cartão devolvido
                            br
                            small(style="font-size:16px; color:#1113128A") ({{ fatura.venda.taxa_servico_maquininha }}% de {{ (fatura.indicadores ? fatura.indicadores.totalTaxaServicoMaquininha : 0) | currency }} referentes a {{ (fatura.indicadores ? fatura.indicadores.quantidadeTaxaServicoMaquininha : 0) }} vendas realizadas com maquininha de cartão)
                        v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#0F7641")
                            strong +{{ (fatura.indicadores ? fatura.indicadores.totalReembolsoTaxaServicoMaquininha : 0) | currency }}
                div(style="border:1px solid; border-radius:8px; color:#0000000A").pa-3.mt-4.mb-4
                    v-layout(row,wrap)
                        v-flex.md8.xs12(style="font-size:18px; color:#111312")
                            strong Valor repassado para a plataforma
                        v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#111312CC")
                            strong {{ (fatura.indicadores ? fatura.indicadores.totalTaxaServicoLiquida : 0) | currency }}

        v-card-actions.mr-4.pb-3
            v-spacer
            v-btn(flat,@click="close()") Fechar

</template>

<script>

export default {
  props: {
  },
  data () {
    return {
        show : false,
        fatura : null
    }
  },
  created () {

  },
  watch: {
  },
  computed: {
  },
  methods: {
    open(fatura){
      const vm = this;
      vm.fatura = fatura;
      vm.show = true;
    },
    close(){
        const vm = this;
        vm.fatura = null;
        vm.show = false;
    }
  }
}
</script>
